import { Box } from "@mui/material";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

export function DataGridToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarDensitySelector
        slotProps={{
          button: { color: "neutral" },
        }}
      />
      <GridToolbarColumnsButton
        slotProps={{
          button: { color: "neutral" },
        }}
      />
      <GridToolbarFilterButton
        slotProps={{
          button: { color: "neutral" },
        }}
      />
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}
